import { defineMessages } from '@dragonraider5/react-intl'

export default defineMessages({
  title: {
    id: 'containers.AccountVerification.title',
    description: 'Account verification title message',
    defaultMessage: 'Verificación de cuenta de usuario'
  },
  requesting: {
    id: 'containers.AccountVerification.requesting',
    description: 'Account verification message when is requesting',
    defaultMessage: 'Verificando cuenta de usuario, por favor espera unos segundos.'
  },
  success: {
    id: 'containers.AccountVerification.success',
    description: 'Account verification message success',
    defaultMessage: 'Gracias por verificar tu cuenta de usuario, ya puedes continuar con tu proceso de solicitud.'
  },
  continueButton: {
    id: 'containers.AccountVerification.buttons.continue',
    description: 'Account verification continue button',
    defaultMessage: 'Continuar solicitud'
  },
  loginButton: {
    id: 'containers.AccountVerification.buttons.login',
    description: 'Account verification failure login button',
    defaultMessage: 'Ir a inicio de sesión'
  }
})
